import { createStyles } from "@mui/material";
import { makeStyles } from "@mui/styles";
import cssVariables from "../theme/cssVariables";

const useStyles = makeStyles(() =>
  createStyles({
    "@global": {
      "*": {
        boxSizing: "border-box",
        margin: 0,
        padding: 0,
      },
      '*::-webkit-scrollbar': {
        width: '0.6em',
        height: "0.4em"
      },
      '*::-webkit-scrollbar-track': {
        '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.1)'
      },
      '*::-webkit-scrollbar-thumb': {
        // backgroundColor: cssVariables.color.black,
        backgroundColor: "#939393",
        borderRadius: "10px"
      },
      html: {
        "-webkit-font-smoothing": "antialiased",
        "-moz-osx-font-smoothing": "grayscale",
        height: "100%",
        width: "100%",
      },
      body: {
        backgroundColor: "#f4f6f8",
        height: "100%",
        width: "100%",
      },
      a: {
        textDecoration: "none",
      },
      "#root": {
        height: "100%",
        width: "100%",
      },
      ".fw-400": {
        fontWeight: "400!important",
      },
      ".fw-500": {
        fontWeight: "500!important",
      },
      ".fw-600": {
        fontWeight: "600!important",
      },
      ".text-decoration-underline": {
        textDecoration: "underline",
      },
      ".black--bg": {
        backgroundColor: `${cssVariables.color.black}!important`,
      },
      ".white--text": {
        color: `${cssVariables.color.white}!important`,
      },
      ".white--bg": {
        backgroundColor: `${cssVariables.color.white}!important`,
      },
      ".disabled--bg": {
        backgroundColor: `#F3F3F3!important`,
      },
      ".red": {
        "&.text": {
          color: cssVariables.color.red,
        },
        "&.bg": {
          backgroundColor: cssVariables.color.red,
        },
      },
      ".bar-legend-circle": {
        background: cssVariables.color.primary,
        width: "14px",
        height: "14px",
        borderRadius: "50%"
      },
      ".bar-legend-square": {
        background: cssVariables.color.primary,
        width: "15px",
        height: "15px",
        borderRadius: "2px"
      },
      ".clickable": {
        cursor: 'pointer'
      },
      ".hoverMember": {
        transition: "0.2s",
        '&:hover': {
          background: 'rgba(93, 161, 150, 0.1) !important',
          borderRadius: "10px"
        }
      },
      ".min-height-card": {
        minHeight: '500px'
      },
      ".searchTextField-h48": {
        "& > div": {
          height: "48px"
        }
      },
      ".btn-large": {
        minWidth: "120px!important",
      },
      "#steppers": {
        "& > *": {
          transition: "all .8s"
        }
      },
      ".svg-black-stroke": {
        '& > path': {
          stroke: '#6B6B6B!important'
        },
        '& g > path': {
          stroke: '#6B6B6B!important'
        },
      },
      "#workload-select": {
        color: "#404349"
      },
      ".ql-container": {
        height: "calc(100% - 42px)!important",
        borderRadius: "0 0 8px 8px!important"
      },
      ".ql-toolbar": {
        borderRadius: "8px 8px 0 0!important"
      },
      ".rti--container": {
        "--rti-bg": "#fff",
        "--rti-border": "#ccc",
        "--rti-main": "#3182ce",
        "--rti-radius": "4px",
        "--rti-s": "10px", /* spacing */
        "--rti-tag": "#4085C9",
        "--rti-tag-remove": "#e53e3e"
      },
      ".rti--tag": {
        borderRadius: "22px!important",
        color: "#fff",
        "& > span": {
          padding: "0 4px!important"
        },
        "& > button": {
          color: "#fff",
          padding: "0 3px!important"
        }
      },
      ".tags-input-container": {
        "border": "1px solid #CED4DA",
        "padding": ".5em",
        "borderRadius": "4px",
        "width": "100%",
        "display": "flex",
        "alignItems": "center",
        "flexWrap": "wrap",
        "gap": ".5em"
      },
      ".tag-item": {
        "backgroundColor": "#4085C9",
        "display": "inline-block",
        "padding": ".5em .75em",
        "borderRadius": "22px"
      },
      ".tag-item .close": {
        "height": "20px",
        "width": "20px",
        "color": "#fff",
        "display": "inline-flex",
        "justifyContent": "center",
        "alignItems": "center",
        "marginLeft": "5px",
        "fontSize": "20px",
        "cursor": "pointer"
      },
      ".tags-input": {
        "flexGrow": "1",
        "padding": ".5em 0",
        "border": "none",
        "outline": "none"
      },
      ".custom-placeholder::placeholder": { /* Chrome, Firefox, Opera, Safari 10.1+ */
        fontWeight: 300,
        color: "#AAAAAA!important",
        opacity: "1!important"
      },
      ".custom-placeholder:-ms-input-placeholder": { /* Internet Explorer 10-11 */
        fontWeight: 300,
        color: "#AAAAAA!important",
        opacity: "1!important"
      },
      ".custom-placeholder::-ms-input-placeholder": { /* Microsoft Edge */
        fontWeight: 300,
        color: "#AAAAAA!important",
        opacity: "1!important"
      },
      ".apexcharts-text tspan": {
        fontFamily: "Kanit!important",
        // fontSize: "14px!important"
      },
      ".dashboard-competency::-webkit-scrollbar-thumb": {
        background: cssVariables.color.primary
      }
    },
  })
);

const GlobalStyles = () => {
  useStyles();

  return null;
};

export default GlobalStyles;
